import SoicialPostsCarousel from './social-posts-carousel/social-posts-carousel.vue'

export default [
  SoicialPostsCarousel,
]
